import { Routes } from '@angular/router';
import { environment } from '@env/environment';
import { routeTranslations } from '../route-translations';
import { TranslateService } from '@ngx-translate/core';
import { inject } from '@angular/core';

export class ShellLocalize {
    static rootRoutes(routes: Routes): Routes {
        return environment.supportedLanguages.map((lang) => {
            return {
                path: lang,
                children: translateRoutes(routes, lang),
            };
        });
    }

    static childRoutes(routes: Routes): Routes {
        const routes2 = environment.supportedLanguages.map((lang) => {
            return {
                path: '',
                canMatch: [
                    () => {
                        const translateService = inject(TranslateService);
                        return lang === translateService.currentLang;
                    },
                ],
                children: translateRoutes(routes, lang),
            };
        });

        return routes2;
    }
}

function translateRoutes(routes: Routes, lang: string): Routes {
    return routes.map((route) => {
        return {
            ...route,
            path: translatePath(route.path, lang),
            children: route.children ? translateRoutes(route.children, lang) : undefined,
            redirectTo: typeof route.redirectTo === 'string' ? translatePath(route.redirectTo, lang) : route.redirectTo,
        };
    });
}

function translatePath(path: string | undefined, lang: string) {
    const parts = path?.split('/') ?? [];
    const translations = routeTranslations(lang);

    const partsTranslated = parts.map((part) => translations[`ROUTES.${part}`] ?? part);

    return partsTranslated.join('/');
}
